import { render, staticRenderFns } from "./offer-header.vue?vue&type=template&id=4cd4a42e&"
import script from "./offer-header.vue?vue&type=script&lang=ts&"
export * from "./offer-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/peter/dev/subscription-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd4a42e')) {
      api.createRecord('4cd4a42e', component.options)
    } else {
      api.reload('4cd4a42e', component.options)
    }
    module.hot.accept("./offer-header.vue?vue&type=template&id=4cd4a42e&", function () {
      api.rerender('4cd4a42e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/offer-header.vue"
export default component.exports